import React, { useState } from "react";
import wishlist from "./wishlist.module.scss";
import { ExternalLink, Gift, X } from "lucide-react";
import getSymbolFromCurrency from "currency-symbol-map";
import { WishlistItemType } from "@src/components/BirthdayTemplate2/Wishlist";

interface Props {
  item: WishlistItemType;
  handleSendMoney: (item: any) => void;
}

const isValidImageUrl = (image?: string | null): boolean => {
  if (!image || image.trim() === "" || image === "not set") return false;
  return image.startsWith("http://") || image.startsWith("https://");
};

const WishlistItem = ({ item, handleSendMoney }: Props) => {
  const [imgError, setImgError] = useState(false);

  const hasImage = isValidImageUrl(item?.image) && !imgError;

  // const [previewImageUrl, setPreviewImageUrl] = React.useState<string | null>(
  //   null
  // );
  // const [previewImageTitle, setPreviewImageTitle] = React.useState("");

  // const openImagePreview = (imageUrl: string, itemName: string) => {
  //   if (!imageUrl) return;
  //   setPreviewImageUrl(imageUrl);
  //   setPreviewImageTitle(itemName);
  // };

  // const closeImagePreview = () => {
  //   setPreviewImageUrl(null);
  //   setPreviewImageTitle("");
  // };

  return (
    <div className={wishlist["wishlist--content__item__outer"]}>
      <div className={wishlist["wishlist--content__item"]}>
        <button
          type="button"
          className={wishlist["wishlist--content__item__image"]}
          // onClick={() =>
          //   openImagePreview(item?.image || "", item?.name || "Wishlist image")
          // }
          disabled={!hasImage}
          aria-label={
            hasImage
              ? `View ${item?.name || "wishlist"} image`
              : `${item?.name || "Wishlist item"} has no image`
          }
        >
          {hasImage ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              src={item?.image || ""}
              alt={item?.name || "Wishlist item"}
              onError={() => setImgError(true)}
            />
          ) : (
            <span
              className={wishlist["wishlist--content__item__imageIcon"]}
              aria-hidden="true"
            >
              <Gift />
            </span>
          )}
        </button>

        <div className={wishlist["wishlist--content__item__left"]}>
          <div className={wishlist["wishlist--content__item__titleRow"]}>
            <p>{item?.name ?? ""}</p>
            {!!item?.link && (
              <a
                target="_blank"
                rel="noreferrer noopener"
                href={item.link}
                className={wishlist["wishlist--content__item__mobileLink"]}
                aria-label={`Open ${item?.name || "wishlist item"} link`}
              >
                <ExternalLink size={10} color="#4d4d4d" />
              </a>
            )}
          </div>
          <h2>
            {!!item && !!item?.amount
              ? `${getSymbolFromCurrency(
                  item?.currency ?? ""
                )} ${(item?.amount).toLocaleString()}`
              : "Not available"}
          </h2>
        </div>
      </div>

      <div className={wishlist["wishlist--content__item__actions"]}>
        <button
          type="button"
          className={wishlist["wishlist--content__btn"]}
          onClick={() => handleSendMoney(item)}
        >
          Send Money
        </button>
        {!!item?.link && (
          <a
            target="_blank"
            rel="noreferrer noopener"
            href={item.link}
            className={wishlist["wishlist--content__item__link"]}
            aria-label={`Open ${item?.name || "wishlist item"} link`}
          >
            <ExternalLink size={16} color="#4d4d4d" />
          </a>
        )}
      </div>

      {/* {previewImageUrl && (
        <div
          className={wishlist["wishlist--preview"]}
          role="dialog"
          aria-modal="true"
          aria-label="Wishlist image preview"
          onClick={closeImagePreview}
        >
          <button
            type="button"
            onClick={closeImagePreview}
            className={wishlist["wishlist--preview__close"]}
            aria-label="Close image preview"
          >
            <X />
          </button>
          <img
            src={previewImageUrl}
            alt={previewImageTitle || "Wishlist item image"}
            className={wishlist["wishlist--preview__image"]}
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )} */}
    </div>
  );
};

export default WishlistItem;
